import { ResponsiveRow } from "../../constants/layout.constants";
import DesktopReportsMenuItem from "../navigation/desktopReportsMenuItem";
import DesktopChildlessMenuItem from "../navigation/desktopChildlessMenuItem";
import { isNullUndefined } from "../../util/util";
import Permit from "../../util/permit";
import DesktopParentMenuItem from "../navigation/desktopParentMenuItem";
import { NavLink } from "react-router-dom";
import { Badge } from "@mui/material";
import { NavMenuItem } from "../../constants/component.constants";

export default function DesktopNavigation({ menus, reports }) {
  return (
    reports &&
    menus &&
    menus.length > 0 && (
      <ResponsiveRow
        sx={{
          display: "flex",
          width: "100%",
          overflow: "visible",
          flexWrap: "nowrap",
          justifyContent: "center",
        }}
      >
        {menus.map((item, index) =>
          isNullUndefined(item.children) ? (
            <DesktopChildlessMenuItem item={item} key={index} />
          ) : (
            <DesktopParentMenuItem item={item} key={index} />
          ),
        )}

        <Permit roles="BLDIR,BLDMG,ACC,REC,CS">
          <DesktopReportsMenuItem reports={reports} />
        </Permit>

        <Permit roles="BLDIR,BLDMG,CS">
          <Badge badgeContent={"New"} color="error">
            <NavMenuItem
              component={NavLink}
              id={"ListingsButton"}
              to={"/listings"}
              sx={{ textDecoration: "none" }}
            >
              {"Listings"}
            </NavMenuItem>
          </Badge>
        </Permit>
      </ResponsiveRow>
    )
  );
}
